<template>
  <div class="app-layout" >
    
     <div class="layout-logo">
       <router-link to="/account/index">
        <el-image class="logo" :src="require('./../assets/login/logo.png')" fit="fit"></el-image>
       </router-link>
    </div>

    <el-row class="app-header hidden-lg">
        <el-menu :default-active="currentRouter" router @select="handleSelect"  mode="horizontal" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
          <el-submenu v-for="(it,index) in meau" :key="index" :index="it.path">
            <template slot="title">
              <span v-if="it.sale > 0" class="tips"></span>
              {{it.title}}
              </template>
            <el-menu-item v-for="(sub,ind) in it.children" :key="ind" :index="sub.path">
              <p v-if="sub.sale > 0" class="tips"></p>
              {{sub.title}}
              </el-menu-item>
          </el-submenu>
        </el-menu>    
    </el-row>

    <el-row class="app-header hidden-md">
        <el-menu :default-active="currentRouter" router  mode="horizontal" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
          <el-submenu v-for="(it,index) in meau" :key="index" :index="it.path">
            <template slot="title">
              <span v-if="it.sale > 0" class="tips"></span>
              {{it.title.substring(0,2)}}
            </template>
            <el-menu-item v-for="(sub,ind) in it.children" :key="ind" :index="sub.path"><p v-if="sub.sale > 0" class="tips"></p>{{sub.title}}</el-menu-item>
          </el-submenu>
        </el-menu>    
    </el-row>

    <div  class="layout-info">
        <el-badge :value="0" class="item">
          <el-dropdown>
            <p>{{user.nickname}}</p>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="signout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        </el-badge>
    </div>
    
  </div>
</template>

<script>
import { mapState, mapActions  } from 'vuex'

export default {
  name: "AppHeader",
  data() {
    return {
      
    }
  },
  methods:{
    ...mapActions([
      'getColumn',
      'getSlider'
    ]),
    handleSelect(index){
      this.meau.forEach(ele => {
        ele.children.forEach(e => {
          if(e.path == index){
            this.getSlider(e)
          }
        })
      });
    },
    signout(){
      this.removeToken()
      this.$router.push({path:'/'})
    }
  },
  computed:{
    currentRouter(){
      let str  = this.$route.path.split('/', 3)
      return str.join('/');
    },
    ...mapState([ 'meau' , 'user']),
  },
  created(){
    this.getColumn()
  }
};
</script>

<style lang="less" scope>
@import "@/untils/public.less";
.app-layout {
  display: flex;
  align-content: center;
  justify-content: space-between;
  background-color: rgb(84, 92, 100);
  min-width: 1200px;
  .layout-logo {
    width: 200px;
    height: 60px;
    .logo{
      width:200px;
      height:60px;
    }
  }
  .app-header {
    width: 100%;
    height: 100%;
    background-color: rgb(84, 92, 100);
    .el-submenu__title {
      font-size: 18px;
      position: relative;
      .tips {
        position: absolute;
        top: 10px;
        right: 31px;
        display: block;
        width: 8px;
        height: 8px;
        background: red;
        border-radius: 50%;
        animation: scale 1s infinite linear alternate;
      }
      @keyframes scale {
        from{transform: scale(1);opacity: 0;}
        to{transform: scale(1.2);opacity: 1;}
      }
    }
  }
  .layout-info {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    width: 170px;
    padding-right:30px;
    .avatar {
      width:38px ;
      height: 38px;
      border-radius: 50%;
      margin-right:10px ;
    }
    p {
      height: 30px;
      line-height: 30px;
      margin: 5px 0;
      color: #fff;
      font-size: 18px;
    }
  }
}
@media screen and (min-width:1420px) {
  .hidden-lg {
    display: inline-block;
  }
  .hidden-md {
    display: none;
  }
}
@media screen and (max-width:1420px) {
  .hidden-lg {
    display: none;
  }
  .hidden-md {
    display: inline-block;
  }
}

</style>
